export default "__VITE_ASSET__BYwAjsGc__"